<div class="modal-wrapper sm" (click)="close()" [class.show]="modalVisible">
  <div class="modal" (click)="$event.stopPropagation();">
    <div class="modal-header">
      <span class="modal-title">{{instance.config.title}}</span>
      <span class="close" (click)="close()">
        <svg class="icon fill-current sm">
          <use xlink:href="#cross"></use>
        </svg>
      </span>
    </div>
    <div class="modal-body">
      <p class="m-0" [innerHTML]="instance.config.message"></p>
    </div>
    <div class="modal-footer text-right">
      <button class="btn btn-secondary" (click)="close(false)">{{config.cancelButton}}</button>
      <button class="btn btn-primary" (click)="close(true)">{{config.acceptButton}}</button>
    </div>
  </div>
</div>
